import { delete_, get, post, put } from ".";

export const getAdmins = (filter) => {
  return get(`/api/admin/user/list?${filter || ""}`, true);
};

export const getReporters = (filter) => {
  return get(`/api/admin/user/get-reporters?${filter || ""}`, true);
};

export const addReporter = (data) => {
  return post(`/api/admin/user/create-reporter`, true, data);
};

export const editReporter = (id, data) => {
  return put(`/api/admin/user/update-reporter/${id}`, true, data);
};

export const getGroupsTrips = (groupId) => {
  return get(`/api/admin/trip/getGroupsTrips/${groupId}`, true);
};

export const getAreaReport = (areaId) => {
  return get(`/api/region/module/getAreaReport/${areaId}`, true, {
    responseType: "blob",
  });
};
export const getAreaDrugReport = (areaId) => {
  return get(`/api/region/module/getAreaDrugReport/${areaId}`, true, {
    responseType: "blob",
  });
};
export const getAreaPatientDrugReport = (areaId) => {
  return get(`/api/region/module/getAreaPatientDrugReport/${areaId}`, true, {
    responseType: "blob",
  });
};

export const getDrugReport = () => {
  return get(`/api/drug/report`, true, {
    responseType: "blob",
  });
};
export const getLogReport = () => {
  return get(`/api/drug/logReport`, true, {
    responseType: "blob",
  });
};

export const changeStatus = (userId, status) => {
  return put(`/api/admin/user/changeStatus/${userId}/${status}`, true);
};
export const changeStatusGroup = (groupId) => {
  return put(`/api/admin/group/toggleActivityStatus/${groupId}`, true);
};

export const changeOwner = (groupId, userId) => {
  return put(`/api/admin/group/setNewOwner/${groupId}/${userId}`, true);
};
export const generateTempCode = (userId) => {
  return post(`/api/admin/user/generateTempCode/${userId}`, true);
};
export const deleteUser = (userId) => {
  return delete_(`/api/admin/user/remove/${userId}`, true);
};

export const updateThreshConfig = (body) => {
  return post(`/api/admin/thresholds`, true, body);
};

export const getDashboardData = () => {
  return get(`/api/admin/dashboard/`, true);
};

export const getAreasPerProvince = (params) => {
  return get(`/api/admin/dashboard/areasPerProvince?${params}`, true);
};

export const getMembersPerProvince = (params) => {
  return get(`/api/admin/dashboard/membersPerProvince?${params}`, true);
};

export const getPatientsPerProvince = (params) => {
  return get(`/api/admin/dashboard/patientsPerProvince?${params}`, true);
};

export const getExternalServicesPerProvince = (params) => {
  return get(
    `/api/admin/dashboard/externalServicesPerProvince?${params}`,
    true,
  );
};

export const getFinantialExternalServicesPerProvince = (params) => {
  return get(
    `/api/admin/dashboard/finantialExternalServicesPerProvince?${params}`,
    true,
  );
};

export const getDrugsPerProvince = (params) => {
  return get(`/api/admin/dashboard/drugsPerProvince?${params}`, true);
};
